import React, {useCallback, useEffect, useState} from 'react';

import {formatDate, toFixedValue} from "../../config";


function ProfitGraphDataTable(props) {
    const classPrefix = props.classPrefix
    const items = [...props.items].sort((a, b) => {
        if (+a['period_from'] < +b['period_from']) {
            return 1;
        }
        if (+a['period_from'] > +b['period_from']) {
            return -1;
        }
        return 0;
    });
    const initialItems = [...props.items].sort((a, b) => {
        if (+a['period_from'] < +b['period_from']) {
            return 1;
        }
        if (+a['period_from'] > +b['period_from']) {
            return -1;
        }
        return 0;
    });
    const translate = props.translate
    const dateName = props.dateName
    const tableName = props.tableName
    const dateNameFunction = props.dateNameFunction
    const summary = props.summary
    const total = props.total


    const [sort, setSort] = useState(false);

    const TableItems = () => {
        let sortedItems = [...items]

        if (sort) {
            if (sort.direction === 'asc') {
                sortedItems.sort((a, b) => {
                    if (+a[sort.key] > +b[sort.key]) {
                        return 1;
                    }
                    if (+a[sort.key] < +b[sort.key]) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                sortedItems.sort((a, b) => {
                    if (+a[sort.key] < +b[sort.key]) {
                        return 1;
                    }
                    if (+a[sort.key] > +b[sort.key]) {
                        return -1;
                    }
                    return 0;
                });
            }
        }

        return sortedItems.map((item, index) => {
            return <div key={`${tableName}-${item.period_from}`}
                        className={`${classPrefix}__table-row ${classPrefix}__table-row--item`}>
                <div className={`${classPrefix}__table-cell`}>{dateNameFunction(item.period_from)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${parseFloat(toFixedValue(item.CycleProfitDONE, 2)) === 0 ? 'hide' : 0}`}>{toFixedValue(item.CycleProfitDONE, 2)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${parseFloat(toFixedValue(item.CycleProfitDONEPrc, 2)) === 0 ? 'hide' : 0}`}>{toFixedValue(item.CycleProfitDONEPrc, 2)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${parseFloat(toFixedValue(item.CycleProfitDONECnt, 2)) === 0 ? 'hide' : 0}`}>{toFixedValue(item.CycleProfitDONECnt, 0)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${parseFloat(toFixedValue(item.AmountForOperDONE, 2)) === 0 ? 'hide' : 0}`}>{toFixedValue(item.AmountForOperDONE, 2)}</div>
            </div>
        })
    }

    const SummaryItems = () => {
        if (!summary) {
            return ''
        }

        if (total.length === 0) {
            return ''
        }

        return <div className={`${classPrefix}__table-header-wrapper`}>
            <div className={`${classPrefix}__table-row`}>
                <div className={`${classPrefix}__table-cell ${classPrefix}__table-cell--big`}>{translate.total}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${classPrefix}__table-cell--big`}>{toFixedValue(total[0].CycleProfitDONE, 2)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${classPrefix}__table-cell--big`}>{toFixedValue(total[0].CycleProfitDONEPrc, 2)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${classPrefix}__table-cell--big`}>{toFixedValue(total[0].CycleProfitDONECnt, 0)}</div>
                <div
                    className={`${classPrefix}__table-cell ${classPrefix}__table-cell--data ${classPrefix}__table-cell--big`}>{toFixedValue(total[0].AmountForOperDONE, 2)}</div>
            </div>
        </div>

    }

    const onClickSort = (key) => {
        setSort((currentSort) => {
            if (!currentSort) {
                return {key, direction: 'asc'}
            } else if (currentSort.key === key && currentSort.direction === 'asc') {
                return {key, direction: 'desc'}
            } else if (currentSort.key === key && currentSort.direction === 'desc') {
                return false
            }
        })

    }

    const setSortButton = (key, direction) => sort && sort.key === key && sort.direction === direction ? 'active' : ''

    return <div className={`${classPrefix}__table`}>
        <div className={`${classPrefix}__table-header-wrapper`}>
            <div className={`${classPrefix}__table-row ${classPrefix}__table-row--header`}>
                <div className={`${classPrefix}__table-cell ${classPrefix}__table-cell--header`} onClick={() => {
                    onClickSort('period_from')
                }}>
                    <div className={`${classPrefix}__table-cell-item`}>{dateName}</div>
                    <div className={`${classPrefix}__table-cell-sort`}>
                        <div
                            className={`${classPrefix}__table-cell-sort-asc ${setSortButton('period_from', 'asc')}`}></div>
                        <div
                            className={`${classPrefix}__table-cell-sort-desc ${setSortButton('period_from', 'desc')}`}></div>
                    </div>

                </div>
                <div className={`${classPrefix}__table-cell ${classPrefix}__table-cell--header`} onClick={() => {
                    onClickSort('CycleProfitDONE')
                }}>
                    <div className={`${classPrefix}__table-cell-item`}>{translate.profitUSDT}</div>
                    <div className={`${classPrefix}__table-cell-sort`}>
                        <div
                            className={`${classPrefix}__table-cell-sort-asc ${setSortButton('CycleProfitDONE', 'asc')}`}></div>
                        <div
                            className={`${classPrefix}__table-cell-sort-desc ${setSortButton('CycleProfitDONE', 'desc')}`}></div>
                    </div>
                </div>
                <div className={`${classPrefix}__table-cell ${classPrefix}__table-cell--header`} onClick={() => {
                    onClickSort('CycleProfitDONEPrc')
                }}>
                    <div className={`${classPrefix}__table-cell-item`}>{translate.profitPercent}</div>
                    <div className={`${classPrefix}__table-cell-sort`}>
                        <div
                            className={`${classPrefix}__table-cell-sort-asc ${setSortButton('CycleProfitDONEPrc', 'asc')}`}></div>
                        <div
                            className={`${classPrefix}__table-cell-sort-desc ${setSortButton('CycleProfitDONEPrc', 'desc')}`}></div>
                    </div>
                </div>
                <div className={`${classPrefix}__table-cell ${classPrefix}__table-cell--header`} onClick={() => {
                    onClickSort('CycleProfitDONECnt')
                }}>
                    <div className={`${classPrefix}__table-cell-item`}>{translate.countCycles}</div>
                    <div className={`${classPrefix}__table-cell-sort`}>
                        <div
                            className={`${classPrefix}__table-cell-sort-asc ${setSortButton('CycleProfitDONECnt', 'asc')}`}></div>
                        <div
                            className={`${classPrefix}__table-cell-sort-desc ${setSortButton('CycleProfitDONECnt', 'desc')}`}></div>
                    </div>
                </div>
                <div className={`${classPrefix}__table-cell ${classPrefix}__table-cell--header`} onClick={() => {
                    onClickSort('AmountForOperDONE')
                }}>
                    <div className={`${classPrefix}__table-cell-item`}>{translate.amountDaily}</div>
                    <div className={`${classPrefix}__table-cell-sort`}>
                        <div
                            className={`${classPrefix}__table-cell-sort-asc ${setSortButton('AmountForOperDONE', 'asc')}`}></div>
                        <div
                            className={`${classPrefix}__table-cell-sort-desc ${setSortButton('AmountForOperDONE', 'desc')}`}></div>
                    </div>
                </div>
            </div>
        </div>
        <div className={`${classPrefix}__table-list`}>
            <TableItems/>
        </div>

        <SummaryItems/>
    </div>


}

export default ProfitGraphDataTable;